/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  PromoteRequestBody,
  PromoteRequestBody$Outbound,
  PromoteRequestBody$outboundSchema,
} from "../components/promoterequestbody.js";

export type PromoteMcpApprovalRequestSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type PromoteMcpApprovalRequestRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  promoteRequestBody: PromoteRequestBody;
};

/** @internal */
export type PromoteMcpApprovalRequestSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const PromoteMcpApprovalRequestSecurity$outboundSchema: z.ZodMiniType<
  PromoteMcpApprovalRequestSecurity$Outbound,
  PromoteMcpApprovalRequestSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function promoteMcpApprovalRequestSecurityToJSON(
  promoteMcpApprovalRequestSecurity: PromoteMcpApprovalRequestSecurity,
): string {
  return JSON.stringify(
    PromoteMcpApprovalRequestSecurity$outboundSchema.parse(
      promoteMcpApprovalRequestSecurity,
    ),
  );
}

/** @internal */
export type PromoteMcpApprovalRequestRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  PromoteRequestBody: PromoteRequestBody$Outbound;
};

/** @internal */
export const PromoteMcpApprovalRequestRequest$outboundSchema: z.ZodMiniType<
  PromoteMcpApprovalRequestRequest$Outbound,
  PromoteMcpApprovalRequestRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    promoteRequestBody: PromoteRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      promoteRequestBody: "PromoteRequestBody",
    });
  }),
);

export function promoteMcpApprovalRequestRequestToJSON(
  promoteMcpApprovalRequestRequest: PromoteMcpApprovalRequestRequest,
): string {
  return JSON.stringify(
    PromoteMcpApprovalRequestRequest$outboundSchema.parse(
      promoteMcpApprovalRequestRequest,
    ),
  );
}
